import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

/** Delay before preloading non-dashboard routes (ms). Keeps initial /dashboard load lean. */
const IDLE_PRELOAD_DELAY_MS = 8000;

@Injectable({
  providedIn: 'root'
})
export class SelectivePreloadStrategy implements PreloadingStrategy {

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (!route.data?.['preload']) {
      return of(null);
    }

    const isDashboardRoute = route.path === 'dashboard';
    const delayMs = isDashboardRoute ? 0 : IDLE_PRELOAD_DELAY_MS;

    // Skip while offline: a failed chunk fetch stays cached by the browser and would break the route
    // after reconnecting. The router re-runs preloading after each navigation, so it is retried later.
    // A failed preload is swallowed so it can't end the preloader; real navigation reports its own errors.
    return timer(delayMs).pipe(
      mergeMap(() => (navigator.onLine ? load() : of(null))),
      catchError(() => of(null))
    );
  }

}
